export default "__VITE_ASSET__DgvEZNfw__"